var base, base1, base2, detectCurrentLocation, events, extendOnDocumentReady, externalObjectLoader, externalObjectLoaderOnready, getConfigFromDom, hasTouch, loadAsyncJS, makeTag, mediaQueries, pageWidths, ref, ref1, setSiteCookies, trackEvent, unparam;

unparam = require('./unparam');

getConfigFromDom = require('./getConfigFromDom');

trackEvent = require('./trackEvent');

makeTag = require('./makeTag');

loadAsyncJS = require('./loadAsyncJS');

detectCurrentLocation = require('../../../src/frontend/helper/search/helper/m_detectCurrentLocation').detectCurrentLocation;

extendOnDocumentReady = require('./groupon_extended');

setSiteCookies = require('./setSiteCookies');

ref = require('./externalObjectLoader'), externalObjectLoader = ref.externalObjectLoader, externalObjectLoaderOnready = ref.externalObjectLoaderOnready;

if (window.Groupon == null) {
  window.Groupon = {};
}

_.extend(window.Groupon, {
  SharedJS: {},
  Widgets: {},
  PageFlags: {}
});

hasTouch = (typeof Modernizr !== "undefined" && Modernizr !== null ? (ref1 = Modernizr.touchevents) != null ? ref1.valueOf() : void 0 : void 0) || 'ontouchstart' in window || window.navigator.maxTouchPoints || (window.DocumentTouch && document instanceof DocumentTouch);

events = hasTouch ? 'touchstart' : 'click';

pageWidths = {
  xxl: 1280,
  xl: 1080,
  slsL: 769,
  l: 720,
  m: 600,
  s: 400
};

mediaQueries = {
  xxlMin: "(min-width: " + pageWidths.xxl + "px)",
  xlMin: "(min-width: " + pageWidths.xl + "px)",
  slsLMin: "(min-width:  " + pageWidths.slsL + "px)",
  lMin: "(min-width:  " + pageWidths.l + "px)",
  mMin: "(min-width:  " + pageWidths.m + "px)",
  sMin: "(min-width:  " + pageWidths.s + "px)",
  xxlMax: "(max-width: " + (pageWidths.xxl - 1) + "px)",
  xlMax: "(max-width: " + (pageWidths.xl - 1) + "px)",
  slsLMax: "(max-width:  " + (pageWidths.slsL - 1) + "px)",
  lMax: "(max-width:  " + (pageWidths.l - 1) + "px)",
  mMax: "(max-width:  " + (pageWidths.m - 1) + "px)",
  sMax: "(max-width:  " + (pageWidths.s - 1) + "px)"
};

if ((base = window.Groupon).LS == null) {
  base.LS = {};
}

_.extend(window.Groupon.LS, {
  hasTouch: hasTouch,
  events: events,
  mediaQueries: mediaQueries,
  pageWidths: pageWidths,
  Header: {}
});

if ((base1 = window.Groupon).Modules == null) {
  base1.Modules = {};
}

if ((base2 = window.Groupon).Utils == null) {
  base2.Utils = {};
}

_.extend(Groupon.Utils, {
  unparam: unparam,
  makeTag: makeTag,
  getConfigFromDom: getConfigFromDom,
  setSiteCookies: setSiteCookies,
  externalObjectLoader: externalObjectLoader,
  externalObjectLoaderOnready: externalObjectLoaderOnready,
  trackEvent: trackEvent,
  loadAsyncJS: loadAsyncJS,
  detectCurrentLocation: detectCurrentLocation
});

extendOnDocumentReady();

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2pwdmVyZGVqby9Hcm91cG9uL3Nscy9jb3JlL2Zyb250ZW5kL2dyb3Vwb25fbW9kdWxlcy9ncm91cG9uLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi9Vc2Vycy9qcHZlcmRlam8vR3JvdXBvbi9zbHMvY29yZS9mcm9udGVuZC9ncm91cG9uX21vZHVsZXMvZ3JvdXBvbi5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQTs7QUFBQSxPQUFBLEdBQVUsT0FBQSxDQUFRLFdBQVI7O0FBQ1YsZ0JBQUEsR0FBbUIsT0FBQSxDQUFRLG9CQUFSOztBQUNuQixVQUFBLEdBQWEsT0FBQSxDQUFRLGNBQVI7O0FBQ2IsT0FBQSxHQUFVLE9BQUEsQ0FBUSxXQUFSOztBQUNWLFdBQUEsR0FBYyxPQUFBLENBQVEsZUFBUjs7QUFDWix3QkFBMEIsT0FBQSxDQUFRLG9FQUFSOztBQUM1QixxQkFBQSxHQUF3QixPQUFBLENBQVEsb0JBQVI7O0FBRXhCLGNBQUEsR0FBaUIsT0FBQSxDQUFRLGtCQUFSOztBQUNqQixNQUVJLE9BQUEsQ0FBUSx3QkFBUixDQUZKLEVBQUUsK0NBQUYsRUFDRTs7O0VBSUYsTUFBTSxDQUFDLFVBQVc7OztBQUVsQixDQUFDLENBQUMsTUFBRixDQUFTLE1BQU0sQ0FBQyxPQUFoQixFQUF5QjtFQUN2QixRQUFBLEVBQVUsRUFEYTtFQUV2QixPQUFBLEVBQVMsRUFGYztFQUd2QixTQUFBLEVBQVcsRUFIWTtDQUF6Qjs7QUFRQSxRQUFBLDBHQUFpQyxDQUFFLE9BQXhCLENBQUEsb0JBQUEsSUFBcUMsY0FBQSxJQUFrQixNQUF2RCxJQUFpRSxNQUFNLENBQUMsU0FBUyxDQUFDLGNBQWxGLElBQW9HLENBQUMsTUFBTSxDQUFDLGFBQVAsSUFBeUIsUUFBQSxZQUFvQixhQUE5Qzs7QUFDL0csTUFBQSxHQUFZLFFBQUgsR0FDUCxZQURPLEdBR1A7O0FBRUYsVUFBQSxHQUNFO0VBQUEsR0FBQSxFQUFLLElBQUw7RUFDQSxFQUFBLEVBQUksSUFESjtFQUVBLElBQUEsRUFBTSxHQUZOO0VBR0EsQ0FBQSxFQUFHLEdBSEg7RUFJQSxDQUFBLEVBQUcsR0FKSDtFQUtBLENBQUEsRUFBRyxHQUxIOzs7QUFPRixZQUFBLEdBQ0U7RUFBQSxNQUFBLEVBQVEsY0FBQSxHQUFlLFVBQVUsQ0FBQyxHQUExQixHQUE4QixLQUF0QztFQUNBLEtBQUEsRUFBTyxjQUFBLEdBQWUsVUFBVSxDQUFDLEVBQTFCLEdBQTZCLEtBRHBDO0VBRUEsT0FBQSxFQUFTLGVBQUEsR0FBZ0IsVUFBVSxDQUFDLElBQTNCLEdBQWdDLEtBRnpDO0VBR0EsSUFBQSxFQUFNLGVBQUEsR0FBZ0IsVUFBVSxDQUFDLENBQTNCLEdBQTZCLEtBSG5DO0VBSUEsSUFBQSxFQUFNLGVBQUEsR0FBZ0IsVUFBVSxDQUFDLENBQTNCLEdBQTZCLEtBSm5DO0VBS0EsSUFBQSxFQUFNLGVBQUEsR0FBZ0IsVUFBVSxDQUFDLENBQTNCLEdBQTZCLEtBTG5DO0VBTUEsTUFBQSxFQUFRLGNBQUEsR0FBYyxDQUFDLFVBQVUsQ0FBQyxHQUFYLEdBQWlCLENBQWxCLENBQWQsR0FBa0MsS0FOMUM7RUFPQSxLQUFBLEVBQU8sY0FBQSxHQUFjLENBQUMsVUFBVSxDQUFDLEVBQVgsR0FBZ0IsQ0FBakIsQ0FBZCxHQUFpQyxLQVB4QztFQVFBLE9BQUEsRUFBUyxlQUFBLEdBQWUsQ0FBQyxVQUFVLENBQUMsSUFBWCxHQUFrQixDQUFuQixDQUFmLEdBQW9DLEtBUjdDO0VBU0EsSUFBQSxFQUFNLGVBQUEsR0FBZSxDQUFDLFVBQVUsQ0FBQyxDQUFYLEdBQWUsQ0FBaEIsQ0FBZixHQUFpQyxLQVR2QztFQVVBLElBQUEsRUFBTSxlQUFBLEdBQWUsQ0FBQyxVQUFVLENBQUMsQ0FBWCxHQUFlLENBQWhCLENBQWYsR0FBaUMsS0FWdkM7RUFXQSxJQUFBLEVBQU0sZUFBQSxHQUFlLENBQUMsVUFBVSxDQUFDLENBQVgsR0FBZSxDQUFoQixDQUFmLEdBQWlDLEtBWHZDOzs7O01BYVksQ0FBQyxLQUFNOzs7QUFDckIsQ0FBQyxDQUFDLE1BQUYsQ0FBUyxNQUFNLENBQUMsT0FBTyxDQUFDLEVBQXhCLEVBQTRCO0VBQzFCLFFBQUEsRUFBVSxRQURnQjtFQUUxQixNQUFBLEVBQVEsTUFGa0I7RUFHMUIsWUFBQSxFQUFjLFlBSFk7RUFJMUIsWUFBQSxVQUowQjtFQUsxQixNQUFBLEVBQVEsRUFMa0I7Q0FBNUI7OztPQVVjLENBQUMsVUFBVzs7OztPQUVaLENBQUMsUUFBUzs7O0FBRXhCLENBQUMsQ0FBQyxNQUFGLENBQVMsT0FBTyxDQUFDLEtBQWpCLEVBQXdCO0VBQ3RCLFNBQUEsT0FEc0I7RUFFdEIsU0FBQSxPQUZzQjtFQUd0QixrQkFBQSxnQkFIc0I7RUFJdEIsZ0JBQUEsY0FKc0I7RUFLdEIsc0JBQUEsb0JBTHNCO0VBTXRCLDZCQUFBLDJCQU5zQjtFQU90QixZQUFBLFVBUHNCO0VBUXRCLGFBQUEsV0FSc0I7RUFTdEIsdUJBQUEscUJBVHNCO0NBQXhCOztBQVlBLHFCQUFBLENBQUEifQ==
